goog.provide("shadow.js.shim.module$$carbon$icons_react$es$TaskComplete$default");
shadow.js.shim.module$$carbon$icons_react$es$TaskComplete$default = shadow.js.require(374, {}).default;
